export default __webpack_public_path__ + "static/BUS-web-homepage-2019-bbdcfba7ee71ac6a9666e6a5c5109e07.png";